<template>
    <div class="financeCalculator__quote">
        <div class="financeCalculator__quoteGrid">
            <div class="financeCalculator__quoteGrid__item" v-if="rate">
                <div class="financeCalculator__quoteGrid__label">Best available rate</div>
                <div class="financeCalculator__quoteGrid__value">{{ rate }}%</div>
            </div>

            <div class="financeCalculator__quoteGrid__item" v-if="totalRepayment">
                <div class="financeCalculator__quoteGrid__label">Total repayment</div>
                <div class="financeCalculator__quoteGrid__value">{{ totalRepayment|formatCurrency }}</div>
            </div>

            <div class="financeCalculator__quoteGrid__item" v-if="totalCostOfCredit">
                <div class="financeCalculator__quoteGrid__label">Total cost of credit</div>
                <div class="financeCalculator__quoteGrid__value">{{ totalCostOfCredit|formatCurrency }}</div>
            </div>

            <div class="financeCalculator__quoteGrid__item" v-if="totalFunded">
                <div class="financeCalculator__quoteGrid__label">Total funded</div>
                <div class="financeCalculator__quoteGrid__value">{{ totalFunded|formatCurrency }}</div>
            </div>
        </div>

        <div class="financeCalculator__quoteTotal" v-if="term && totalMonthly">
            <div class="financeCalculator__quoteTotal__label">
                {{ term }} monthly payments of
            </div>

            <div class="financeCalculator__quoteTotal__value">
                {{ totalMonthly|formatCurrency }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rate: {
            type: Number,
        },
        totalRepayment: {
            type: Number
        },
        totalCostOfCredit: {
            type: Number
        },
        totalFunded: {
            type: Number
        },
        term: {
            type: Number
        },
        totalMonthly: {
            type: Number
        },
    },
    filters: {
        formatCurrency(value) {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(value);
        },
    }
}
</script>